// extracted by mini-css-extract-plugin
export default {"welcome":"_7GmQ6huwljHE8TQcUt2S1"};